import { forwardRef, useId } from "react";
import { Kbd } from "app/components/shared/Kbd";
import Icon from "app/components/shared/Icon";

export const StepSearchInput = forwardRef<HTMLInputElement, React.HTMLProps<HTMLInputElement>>(
  (props, ref) => {
    const id = useId();

    return (
      <div className="relative flex max-w-full items-center">
        <label htmlFor={id} className="sr-only">
          Search steps
        </label>

        <input
          {...props}
          id={id}
          ref={ref}
          placeholder=""
          className="input peer px-2 py-1 text-sm"
        />
        <span
          className="pointer-events-none absolute flex w-full items-center gap-1 truncate px-2 text-left text-charcoal-300 peer-[:not(:placeholder-shown)]:hidden"
          aria-hidden="true"
        >
          <Icon icon="heroicons/16/solid/magnifying-glass" className="h-4 w-4" />
          <span>Type </span>
          <Kbd>S</Kbd>
          <span> to search</span>
        </span>
      </div>
    );
  },
);
